<template>
  <r-data-list
    :headdata="headdata"
    :listdata="listData"
    :opt="opts"
    v-if="loaded"
  >
    <template v-slot:titleextrabuttons>
      <r-btn
        type="secondary"
        @click="saveReorder"
        v-if="listData && listData.length > 0"
        >Sıralamayı Kaydet</r-btn
      >
    </template>
    <template v-slot:rowextrabtn="{ datarow }">
      <r-btn @click="openEdit(datarow)">Düzenle</r-btn>
      <r-btn @click="openValues(datarow)" type="secondary"
        >Değerleri Yönet</r-btn
      >
      <r-btn
        @click="toggleDefinition(datarow)"
        :type="datarow.isActive ? 'danger' : 'success'"
        >{{ datarow.isActive ? "Pasif Et" : "Aktif Et" }}</r-btn
      >
      <r-btn @click="deleteDefinition(datarow)" type="danger">Sil</r-btn>
    </template>
  </r-data-list>

  <property-definition-modal
    v-model="showForm"
    :definition="form"
    :title="formTitle"
    :defaultSortOrder="listData && listData.length ? listData.length + 1 : 1"
    @save="saveForm"
  />

  <r-modal
    v-model:isactive="showValues"
    :title="'Değerler - ' + (selectedDefinition?.name || '')"
    width="700px"
  >
    <div v-if="valuesLoaded">
      <r-data-list :headdata="valueHeads" :listdata="values" :opt="valueOpts">
        <template v-slot:titleextrabuttons>
          <r-btn @click="addValue">Yeni Değer</r-btn>
          <r-btn
            type="secondary"
            @click="saveValuesReorder"
            v-if="values && values.length > 0"
            >Sıralamayı Kaydet</r-btn
          >
        </template>
        <template v-slot:rowextrabtn="{ datarow }">
          <r-btn @click="editValue(datarow)">Düzenle</r-btn>
          <r-btn
            :type="datarow.isActive ? 'danger' : 'success'"
            @click="toggleValue(datarow)"
            >{{ datarow.isActive ? "Pasif Et" : "Aktif Et" }}</r-btn
          >
          <r-btn type="danger" @click="deleteValue(datarow)">Sil</r-btn>
        </template>
      </r-data-list>
    </div>
  </r-modal>
</template>

<script>
import { ref, onBeforeMount, computed } from "vue";
import PropertyDefinitionModal from "./PropertyDefinitionModal.vue";
import { useStore } from "vuex";

export default {
  components: { PropertyDefinitionModal },
  setup() {
    const store = useStore();
    const loaded = ref(false);
    const listData = ref([]);
    const showForm = ref(false);
    const formTitle = ref("Yeni Özellik");
    const form = ref({
      id: null,
      name: "",
      description: "",
      dataType: 1,
      displayType: 1,
      cardinality: 1,
      isRequired: false,
      sortOrder: 1,
      isActive: true
    });
    const showValues = ref(false);
    const selectedDefinition = ref(null);
    const values = ref([]);
    const valuesLoaded = ref(false);

    // Enums modal içinde yönetiliyor; burada ayrıca tanımlamaya gerek yok

    const headdata = computed(() => [
      { title: "Ad", key: "name", style: { width: "20%" } },
      { title: "Veri Tipi", key: "dataType", style: { width: "10%" } },
      { title: "Görünüm", key: "displayType", style: { width: "12%" } },
      { title: "Çokluk", key: "cardinality", style: { width: "10%" } },
      {
        title: "Zorunlu",
        key: "isRequired",
        type: "checkbox",
        style: { width: "8%", justifyContent: "center" }
      },
      {
        title: "Aktif",
        key: "isActive",
        type: "checkbox",
        style: { width: "8%", justifyContent: "center" }
      },
      { title: "Sıra", key: "sortOrder", style: { width: "8%" } }
    ]);

    const opts = ref({
      title: "Özellik Tanımları",
      buttons: { style: { width: "30%" } }
    });

    const valueHeads = computed(() => [
      { title: "Değer", key: "value", style: { width: "35%" } },
      { title: "Görüntü Metni", key: "displayText", style: { width: "35%" } },
      {
        title: "Aktif",
        key: "isActive",
        type: "checkbox",
        style: { width: "10%", justifyContent: "center" }
      },
      { title: "Sıra", key: "sortOrder", style: { width: "10%" } }
    ]);

    const valueOpts = ref({
      title: "Değerler",
      buttons: { style: { width: "20%" } }
    });

    const getDefinitions = async () => {
      const res = await store.dispatch("getDatas", {
        api: "PropertyDefinitions"
      });
      const arr = res && (res.data ?? res.Data);
      listData.value = Array.isArray(arr) ? arr : [];
      if (!Array.isArray(arr)) {
        console.warn("PropertyDefinitions GET unexpected response:", res);
      }
    };
    const getValues = async id => {
      const res = await store.dispatch("getDatas", {
        api: `PropertyDefinitions/${id}/values`
      });
      const arr = res && (res.data ?? res.Data);
      values.value = Array.isArray(arr) ? arr : [];
    };

    const openCreate = () => {
      formTitle.value = "Yeni Özellik";
      form.value = {
        id: null,
        name: "",
        description: "",
        dataType: 1,
        displayType: 1,
        cardinality: 1,
        isRequired: false,
        sortOrder: (listData.value?.length || 0) + 1,
        isActive: true
      };
      showForm.value = true;
    };
    // Header butonunu RDataList'in default add butonuna da bağlayalım
    opts.value.buttons.add = {
      show: true,
      pos: "title",
      txt: "Yeni Özellik",
      func: openCreate
    };
    const openEdit = async d => {
      formTitle.value = "Özellik Düzenle";
      // Detay bilgisini values ile birlikte çek
      const res = await store.dispatch("getDatas", {
        api: `PropertyDefinitions/${d.id}/detail`
      });
      if (res && res.result && res.data) {
        const detail = res.data;
        form.value = {
          id: detail.id,
          name: detail.name || "",
          description: detail.description || "",
          dataType: detail.dataType,
          displayType: detail.displayType,
          cardinality: detail.cardinality,
          isRequired: detail.isRequired || false,
          sortOrder: detail.sortOrder || 1,
          isActive: detail.isActive !== undefined ? detail.isActive : true,
          values: detail.values || detail.propertyDefinitionValues || []
        };
      } else {
        // Fallback: sadece mevcut datayı kullan
        form.value = { ...d };
      }
      showForm.value = true;
    };
    const saveForm = async payload => {
      const data = payload || form.value;
      if (!data.name) return;
      // Normalize types to satisfy backend enum/int expectations
      data.dataType = Number(data.dataType);
      data.displayType = Number(data.displayType);
      data.cardinality = Number(data.cardinality);
      data.isRequired = !!data.isRequired;
      data.sortOrder = Number(data.sortOrder || 1);
      const isUpdate = !!data.id;
      const api = isUpdate
        ? "PropertyDefinitions/Update"
        : "PropertyDefinitions/Add";
      // API yalnızca json bekler, geçici alanları göndermeyelim
      const clean = { ...data };
      delete clean.__values;
      const res = await store.dispatch("postDatas", { api, data: clean });
      if (res && res.result) {
        // Eğer modal çoklu değer girdiyse, onları da kaydedelim
        if (payload && payload.__values && payload.__values.length > 0) {
          const defId =
            res && res.data && res.data.id ? res.data.id : data.id || null;
          if (defId) {
            for (const v of payload.__values) {
              const valApi = v.id
                ? "PropertyDefinitions/UpdateValue"
                : "PropertyDefinitions/AddValue";
              const vdata = { ...v, propertyDefinitionId: defId };
              vdata.sortOrder = Number(vdata.sortOrder || 1);
              await store.dispatch("postDatas", { api: valApi, data: vdata });
            }
          }
        }
        showForm.value = false;
        await getDefinitions();
      }
    };

    const openValues = async d => {
      selectedDefinition.value = d;
      valuesLoaded.value = false;
      await getValues(d.id);
      valuesLoaded.value = true;
      showValues.value = true;
    };
    const toggleDefinition = async d => {
      await store.dispatch("postDatas", {
        api: `PropertyDefinitions/${d.id}/toggle`
      });
      await getDefinitions();
    };
    const deleteDefinition = async d => {
      await store.dispatch("postDatas", {
        api: `PropertyDefinitions/delete/${d.id}`,
        data: {}
      });
      await getDefinitions();
    };
    const saveReorder = async () => {
      const ids = listData.value.map(x => x.id);
      await store.dispatch("postDatas", {
        api: "PropertyDefinitions/reorder",
        data: ids
      });
      await getDefinitions();
    };

    const addValue = () => {
      values.value.push({
        id: null,
        propertyDefinitionId: selectedDefinition.value.id,
        value: "",
        displayText: "",
        isActive: true,
        sortOrder: (values.value.length || 0) + 1
      });
    };
    const editValue = async v => {
      if (!v.value) return;
      const api = "PropertyDefinitions/values/upsert";
      const res = await store.dispatch("postDatas", { api, data: v });
      if (res && res.result) await getValues(selectedDefinition.value.id);
    };
    const deleteValue = async v => {
      await store.dispatch("postDatas", {
        api: `PropertyDefinitions/values/${v.id}/delete`,
        data: {}
      });
      await getValues(selectedDefinition.value.id);
    };
    const toggleValue = async v => {
      await store.dispatch("postDatas", {
        api: `PropertyDefinitions/values/${v.id}/toggle`,
        data: {}
      });
      await getValues(selectedDefinition.value.id);
    };
    const saveValuesReorder = async () => {
      const ids = values.value.map(x => x.id).filter(Boolean);
      await store.dispatch("postDatas", {
        api: "PropertyDefinitions/values/reorder",
        data: ids
      });
      await getValues(selectedDefinition.value.id);
    };

    onBeforeMount(async () => {
      await store.dispatch("getWorkFolder");
      await getDefinitions();
      loaded.value = true;
    });

    return {
      store,
      loaded,
      listData,
      headdata,
      opts,
      openCreate,
      openEdit,
      showForm,
      formTitle,
      form,
      saveForm,
      openValues,
      showValues,
      selectedDefinition,
      values,
      valuesLoaded,
      valueHeads,
      valueOpts,
      toggleDefinition,
      deleteDefinition,
      saveReorder,
      addValue,
      editValue,
      deleteValue,
      toggleValue,
      saveValuesReorder
    };
  }
};
</script>

<style scoped>
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}
</style>
